export enum UserTypeEnum {
  du = 'du',
  hu = 'hu',
  unknown = 'unknown',
}

export type SocketTypes = {
  userId: string;
};
